import { Injectable } from '@angular/core';
import { HelpTextDictionary } from '../../../core/model/help-text';
import { HelpTextFactory } from '../../../core/service/factory/help-text-factory.service';

@Injectable()
export class PropertyHelpTextService {
  constructor(private _factory: HelpTextFactory) {}

  getDictionary(): HelpTextDictionary {
    return { PROPERTYNAME: this._factory.create('PROPERTY.HELP_TEXT.PROPERTYNAME') };
  }
}
